import "@hotwired/turbo"

import { type TurboFrameMissingEvent, type TurboSession } from "hotwired__turbo"

declare global {
  interface Window {
    Turbo: typeof Turbo
  }
}

// Hack around session apparently not having drive member
interface TurboSessionWithDrive extends TurboSession {
  drive: boolean
}

// Disable Turbo drive by default
;(Turbo.session as TurboSessionWithDrive).drive = false

// Hide frames with missing content by default
document.addEventListener("turbo:frame-missing", (e: TurboFrameMissingEvent) => {
  const target = e.target as HTMLElement
  target.hidden = true
})
